export default {
  items: [
    {
      name: 'Home',
      url: '/',
      icon: 'icon-home'
    },
    {
      name: 'Change Password',
      url: '/user/change-password',
      icon: 'icon-key'
    },
    {
      name: 'Logout',
      url: '/auth/logout',
      icon: 'icon-logout'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js